import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, PlayCircle } from "@phosphor-icons/react";
import { assetUrl } from "@/lib/api";

const categoryLabels = { news: "News", reviews: "Review", videos: "Video", features: "Feature" };

function formatDate(d) {
    try {
        return new Date(d).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
    } catch { return ""; }
}

export default function PostCard({ post, size = "md" }) {
    const isVideo = post.category === "videos";
    return (
        <Link
            to={`/post/${post.slug}`}
            data-testid={`post-card-${post.slug}`}
            className="tz-card group block overflow-hidden"
        >
            <div className={`relative overflow-hidden bg-zinc-900 ${size === "lg" ? "aspect-[16/10]" : "aspect-[16/10]"}`}>
                {post.cover_image ? (
                    <img
                        src={assetUrl(post.cover_image)}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                        loading="lazy"
                    />
                ) : (
                    <div className="w-full h-full bg-zinc-900 grid-overlay" />
                )}
                {isVideo && (
                    <div className="absolute inset-0 grid place-items-center bg-black/40">
                        <PlayCircle size={64} weight="fill" className="text-[#FFD000] drop-shadow-lg" />
                    </div>
                )}
                <div className="absolute top-4 left-4">
                    <span className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] bg-[#FFD000] text-black px-2 py-1">
                        {categoryLabels[post.category] || post.category}
                    </span>
                </div>
            </div>

            <div className="p-6">
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-3">
                    {formatDate(post.created_at)} <span className="mx-2 text-zinc-700">/</span> {post.author_name}
                </div>
                <h3 className={`font-display text-white tracking-tight leading-[1.05] group-hover:text-[#FFD000] transition-colors ${
                    size === "lg" ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"
                }`}>
                    {post.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed line-clamp-2">
                    {post.excerpt}
                </p>
                <div className="mt-5 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#FFD000]">
                    Read <ArrowUpRight size={14} weight="bold" className="group-hover:rotate-45 transition-transform" />
                </div>
            </div>
        </Link>
    );
}
